const initialState = {
    list: [],
    total: "",
    searchKey: "",
  };
  
  export const UsersRoleListReducer = (state = initialState, action) => {
    
    switch (action.type) {
      case "MANAGE_USER_RESPONSE":
        return {
          ...state,
          list: [...action.data.list],
          total: action.data.total,
        };
  
      default:
        return state;
    }
  };
  
